import chevron from '@amo/core/assets/images/icons/chevron-left-white.svg';
import { normalizeTel } from '@amo/core/utils/normalize.js';
import { getStepBySlug } from '../../../../utils/function';
import NavBar from './NavBar';
import FlecheGauche from '../../../../assets/images/icone-fleche-gauche-grise.png'
import {getTranslation} from "@amo/core/utils/functions.js";
import SwitchLanguage from "@amo/core/components/containers/SwitchLanguage/SwitchLanguage.jsx";
import calendarIcon from '@amo/core/assets/images/icons/calendar.svg';
import './header.scss';

const Header = (props) => {
    const {
        previousQuestion,
        indexQuestion,
        step,
        nbQuestions,
        routes,
        setShowBooking,
        logo,
        nameWhitelabel,
        apporteur2,
        utm_source,
        apporteur1,
        analyticsSetEvent,
        isTarifOnePage,
        onPreviousClick,
    } = props;

    const handlePrevious = () => {
        if (onPreviousClick) {
            onPreviousClick();
        } else {
            previousQuestion();
        }
    };

    const isCompactHeader = isTarifOnePage && step === getStepBySlug('votre-tarif');
    let tel;

    const handleResetAndRedirect = () => {
        localStorage.clear();
        window.location = '/'
    };

    const telApporteur2 = {
        67256: '0279834142',
        100122: '0219011492',
        101853: '0219011491',
        393798: '0279834145',
    };

    if (apporteur1.codeBelair === 809466) {
        tel = '0487937213';
    } else if (apporteur2) {
        tel = telApporteur2[apporteur2.codeBelair] || (utm_source === 'lrdm' ? '0219011493' : '0219011494');
    } else if (utm_source === 'april') {
        tel = '0255453459';
    } else {
        tel = utm_source === 'lrdm' ? '0219011493' : '0219011494';
    }

    return (
        <div className={`header f-12 ${isCompactHeader ? 'header--compact' : ''}`}>
            <div className={isCompactHeader ? 'py-lg-2 px-lg-4 px-2 py-1' : 'py-lg-4 px-lg-5 px-2 py-2'}>
                <div className={'container-fluid'}>
                    <div
                        className={`row ${step !== getStepBySlug('confirmation-devis') ? 'justify-content-between' : 'justify-content-center'} align-items-${isCompactHeader ? 'center' : 'baseline'}`}
                    >
                        {(indexQuestion === 0 && step === 0 && step <= getStepBySlug('recapitulatif')) || step === getStepBySlug('confirmation-devis') ? null : (
                            <div className="col-2 d-lg-none d-xl-none">
                                <button type="button" className={'btn btn-return-small me-3'} onClick={() => handlePrevious()} aria-label="Question précédente">
                                    <img src={chevron} alt="" width={12} aria-hidden="true" />
                                </button>
                            </div>
                        )}

                        {step !== getStepBySlug('confirmation-devis') && (
                            <div className={'col-xl-2 d-none d-lg-block text-center'}>
                                {(indexQuestion === 0 && step === 0 && step <= getStepBySlug('recapitulatif')) ? null : (
                                    <button type="button" className={`btn btn-return btn-smaller  me-3`} onClick={() => handlePrevious()}>
                                        <img src={FlecheGauche} alt="" aria-hidden="true" style={{ width: 20, marginRight: 8 }} />
                                        {getTranslation('header.previousQuestion')}
                                    </button>
                                )}
                            </div>
                        )}

                        <div className="col-4 col-md-2 col-xl-1 text-end">
                            <img src={logo} alt="" aria-hidden="true" style={{ maxWidth: isCompactHeader ? 80 : 115, width: '100%' }} />
                        </div>

                        {step !== getStepBySlug('confirmation-devis') && (
                            <div className={`d-none d-lg-block col-xl-6 text-center`}>
                                <NavBar nbQuestions={nbQuestions} routes={routes} activeStep={step} indexQuestion={indexQuestion} />
                            </div>
                        )}

                        <div className="d-none d-lg-block col-xl-3 text-center position-relative">
                            {isCompactHeader ? (
                                <div className="d-flex align-items-center justify-content-end gap-3">
                                    <button
                                        className="btn btn-outline-primary btn-phone-compact"
                                        aria-label={`Un conseiller vous aide, appeler le ${normalizeTel(tel)}`}
                                        onClick={() => {
                                            analyticsSetEvent({
                                                event: 'clickToCall',
                                                datas: { clickToCall: { number: tel } },
                                            });
                                            document.location.href = `tel:${tel}`;
                                        }}
                                    >
                                        <span className={'icon'}></span>
                                        <span>{normalizeTel(tel)}</span>
                                    </button>
                                    <div className="d-flex flex-column align-items-end" style={{ gap: 2 }}>
                                        <button
                                            type="button"
                                            className="text-secondary f-11 fw-bolder cursor-pointer bg-transparent border-0 p-0"
                                            onClick={() => setShowBooking(true)}
                                            dangerouslySetInnerHTML={{ __html: getTranslation('header.orRecallMe') }}
                                        />
                                        <button type="button" className="underline-link cursor-pointer bg-transparent border-0 p-0 f-11" onClick={() => handleResetAndRedirect()}>
                                            {getTranslation('restartQuote')}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                step <= getStepBySlug('recapitulatif') &&
                                step !== getStepBySlug('confirmation-devis') && (
                                    <>
                                        <button
                                            className={'btn btn-phone-filled'}
                                            aria-label={`Un conseiller vous aide, appeler le ${normalizeTel(tel)}`}
                                            onClick={() => {
                                                analyticsSetEvent({
                                                    event: 'clickToCall',
                                                    datas: { clickToCall: { number: tel } },
                                                });
                                                document.location.href = `tel:${tel}`;
                                            }}
                                        >
                                            <span className={'icon'}></span>
                                            <div className={'btn-phone-filled__text'}>
                                                <small>{getTranslation('header.advisorHelpYou')}</small>
                                                <span>
                                                    <span className={'fw-normal'}>le</span> {normalizeTel(tel)}
                                                </span>
                                            </div>
                                        </button>
                                        {/* dangerouslySetInnerHTML uses trusted i18n strings only (getTranslation) */}
                                        <button type="button" className={'btn btn-rappel mx-auto mt-2'} onClick={() => setShowBooking(true)}>
                                            <img src={calendarIcon} alt="" aria-hidden="true" width={20} height={20} />
                                            <span dangerouslySetInnerHTML={{ __html: getTranslation('header.orRecallMe') }} />
                                        </button>
                                        {apporteur1.codeBelair === '43397' && (
                                            <small className={'f-10'}>
                                                {getTranslation('header.alreadyClient')}{' '}
                                                <button
                                                    className={'text-grey text-decoration-none btn btn-link f-10 p-0 m-0 align-baseline border-0'}
                                                    onClick={() => {
                                                        analyticsSetEvent({
                                                            event: 'clickToCall',
                                                            datas: { clickToCall: { number: '0247510707' } },
                                                        });
                                                        document.location.href = `tel:0247510707`;
                                                    }}
                                                >
                                                    <strong>02 47 51 07 07</strong>
                                                </button>
                                            </small>
                                        )}
                                        <br />
                                        <button type="button" className={'underline-link mt-2 cursor-pointer d-inline-block bg-transparent border-0 p-0'} onClick={() => handleResetAndRedirect()}>
                                            <strong>{getTranslation('restartQuote')}</strong>
                                        </button>
                                        <div className="header-centered-dropdown">
                                            {/* En attente du juridique
                                            <hr width={'50%'} className={'mx-auto'}/>
                                            <SwitchLanguage/>
                                             */}
                                        </div>
                                    </>
                                )
                            )}
                        </div>

                        {step <= getStepBySlug('recapitulatif') && step !== getStepBySlug('confirmation-devis') && (
                            <div className={`d-block d-lg-none d-xl-none ${isCompactHeader ? 'col-3' : 'col-6'} text-end`}>
                                <div className={'d-inline-block me-2 align-middle'}>{/* En attente du juridique <SwitchLanguage/>*/}</div>
                                <button type="button" className={'btn btn-outline-primary btn-phone-small'} onClick={() => setShowBooking(true)} aria-label="Demander un rappel">
                                    &nbsp;
                                </button>
                            </div>
                        )}

                        {step !== getStepBySlug('confirmation-devis') && (
                            <div className="d-block d-lg-none d-xl-none col-12 text-center mt-4">
                                <NavBar nbQuestions={nbQuestions} routes={routes} activeStep={step} indexQuestion={indexQuestion} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;